module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/times_off-2cf988e30a58e81f9d47952390612d0b.gif";